import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";
import { toast } from "react-toastify";

export const empAccountStatus = createAsyncThunk('empAccountStatus/updateEmpAccountStatus',
    async ({ userId, status }, { rejectWithValue }) => {
        try {
            const statusBool = status === 'active';
            const response = await axiosPrivate.get(
                `${api.updateAccountStatus}${userId}?status=${statusBool}`,
                {}
            );
            if (response.data.success === true) {
                toast.success(response.data.reason || "account status updated successfully", {
                    className: "toast-success-custom",
                });

            } else {
                toast.error(response.data.reason || "account status updated successfully", {
                    className: "toast-error-custom",
                });
            }
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
        }
    })

const updateEmpAccountStatusSlice = createSlice({
    name: 'empAccountStatus',
    initialState: {
        status: 'idle',
        loading: false,
        error: null
    },
    reducers: {
        resetEmpAccStatus: (state) => {
            state.status = 'idle';
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builders) => {
        builders
            .addCase(empAccountStatus.pending,
                (state) => {
                    state.status = 'loading';
                    state.loading = true;
                    state.error = null;
                })
            .addCase(empAccountStatus.fulfilled,
                (state, action) => {
                    state.status = 'succeeded';
                    state.loading = false;
                })
            .addCase(empAccountStatus.rejected,
                (state, action) => {
                    state.status = 'failed';
                    state.loading = false;
                    state.error = action.payload;
                }
            )
    }
})

export const { resetEmpAccStatus } = updateEmpAccountStatusSlice.actions;
export default updateEmpAccountStatusSlice.reducer;